import React from "react";

const CollectionsContext = React.createContext({});
const DisclaimerProcessorContext = React.createContext({});
const SelectedLocaleContext = React.createContext({});
const ExposeContentContext = React.createContext({});
const PageInstanceContext = React.createContext({});
const ExportStateContext = React.createContext({});
const PageListContext = React.createContext({});

export {
  CollectionsContext,
  DisclaimerProcessorContext,
  SelectedLocaleContext,
  ExposeContentContext,
  PageInstanceContext,
  ExportStateContext,
  PageListContext
};
